var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { GET_THEMATIC_REQUEST, GET_THEMATIC_REQUEST_ERROR, GET_THEMATIC_REQUEST_SUCCESS } from "../actions/getThematics";
export var initialState = {
    isFetching: false,
    isError: false,
    data: [],
};
export function getThematics(state, action) {
    if (state === void 0) { state = initialState; }
    switch (action.type) {
        case GET_THEMATIC_REQUEST:
            return __assign(__assign({}, state), { isFetching: true });
        case GET_THEMATIC_REQUEST_SUCCESS:
            return __assign(__assign({}, state), { isFetching: false, data: action.payload.data });
        case GET_THEMATIC_REQUEST_ERROR:
            return __assign(__assign({}, state), { isFetching: false, isError: true });
        default:
            return state;
    }
}
//# sourceMappingURL=getThematics.js.mapvar __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { GET_THEMATIC_REQUEST, GET_THEMATIC_REQUEST_ERROR, GET_THEMATIC_REQUEST_SUCCESS } from "../actions/getThematics";
export var initialState = {
    isFetching: false,
    isError: false,
    data: [],
};
export function getThematics(state, action) {
    if (state === void 0) { state = initialState; }
    switch (action.type) {
        case GET_THEMATIC_REQUEST:
            return __assign(__assign({}, state), { isFetching: true });
        case GET_THEMATIC_REQUEST_SUCCESS:
            return __assign(__assign({}, state), { isFetching: false, data: action.payload.data });
        case GET_THEMATIC_REQUEST_ERROR:
            return __assign(__assign({}, state), { isFetching: false, isError: true });
        default:
            return state;
    }
}
//# sourceMappingURL=getThematics.js.map